import {
  COPY_TRADING_MY_PROVIDER_PORTFOLIO_EDIT_ROUTE,
  COPY_TRADING_MY_PROVIDER_PORTFOLIO_ROUTE,
  COPY_TRADING_MY_SUBSCRIPTIONS_DETAILS_ROUTE,
  COPY_TRADING_MY_SUBSCRIPTIONS_ROUTE,
  COPY_TRADING_PROVIDER_DETAILS_ROUTE,
  COPY_TRADING_ROUTE,
} from "_constants";
import { lazy } from "react";

const CopyTrading = lazy(() => import("pages/copy-trading"));
const CopyTradingMyProviderPortfolio = lazy(() =>
  import("pages/copy-trading/my-provider-portfolio")
);
const CopyTradingMyProviderPortfolioEdit = lazy(() =>
  import("pages/copy-trading/my-provider-portfolio/edit")
);
const CopyTradingProviderDetailsView = lazy(() =>
  import("pages/copy-trading/provider-details-view")
);
const CopyTradingMySubscriptions = lazy(() =>
  import("pages/copy-trading/my-subscriptions")
);
const CopyTradingMySubscriptionsDetails = lazy(() =>
  import("pages/copy-trading/my-subscriptions/details")
);

export const copyTradingRoutes = [
  { path: COPY_TRADING_ROUTE, element: <CopyTrading /> },
  {
    path: COPY_TRADING_MY_PROVIDER_PORTFOLIO_ROUTE,
    element: <CopyTradingMyProviderPortfolio />,
  },
  {
    path: COPY_TRADING_MY_PROVIDER_PORTFOLIO_EDIT_ROUTE,
    element: <CopyTradingMyProviderPortfolioEdit />,
  },
  {
    path: `${COPY_TRADING_PROVIDER_DETAILS_ROUTE}/:providerId`,
    element: <CopyTradingProviderDetailsView />,
  },
  {
    path: COPY_TRADING_MY_SUBSCRIPTIONS_ROUTE,
    element: <CopyTradingMySubscriptions />,
  },
  {
    path: `${COPY_TRADING_MY_SUBSCRIPTIONS_DETAILS_ROUTE}/:subscriptionId`,
    element: <CopyTradingMySubscriptionsDetails />,
  },
];
